import React from 'react';
import { Box, Table } from '@mantine/core';
import { IMenuItems } from '../types';

type EventSalesProps = {
  menuItems: IMenuItems[];
  totalOrderedItems: number;
};

export const EventSales: React.FC<EventSalesProps> = ({ menuItems, totalOrderedItems }) => {
  const totalQuantity = menuItems.reduce((s, item) => s + item.quantity, 0);
  const showOthers = totalQuantity < totalOrderedItems;

  return (
    <Box bdrs="md" bd="1px solid var(--mantine-color-gray-4)" style={{ overflow: 'hidden' }}>
      <Table fz="sm">
        <Table.Thead>
          <Table.Tr>
            <Table.Th>Item</Table.Th>
            <Table.Th ta="center" w="70px">
              Qty
            </Table.Th>
          </Table.Tr>
        </Table.Thead>
        <Table.Tbody>
          {menuItems?.length > 0 ? (
            menuItems?.map(({ name, quantity, id }) => (
              <Table.Tr key={id}>
                <Table.Td>{name}</Table.Td>
                <Table.Td ta="center">{quantity}</Table.Td>
              </Table.Tr>
            ))
          ) : (
            <Table.Tr>
              <Table.Td colSpan={2} ta="center" fw="bold">
                No orders available
              </Table.Td>
            </Table.Tr>
          )}
          {showOthers ? (
            <Table.Tr>
              <Table.Td>Other</Table.Td>
              <Table.Td ta="center">{totalOrderedItems - totalQuantity}</Table.Td>
            </Table.Tr>
          ) : null}
        </Table.Tbody>
        <Table.Tfoot bg="gray.1">
          <Table.Tr>
            <Table.Th tt="uppercase">Total</Table.Th>
            <Table.Th ta="center">{totalOrderedItems}</Table.Th>
          </Table.Tr>
        </Table.Tfoot>
      </Table>
    </Box>
  );
};
